import React from 'react';
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../components/icon/iconfont';
import { useHistory } from 'react-router-dom';

const Slot = props => {
    const {children} = props
    return children ? <div>{children}</div>: <React.Fragment></React.Fragment>
}

const MeHeaderBase = props => {
    const {children} = props

    return <div className={classes.SlotBox}>
        <div className={classes.Left}>
            <Slot name='left' children={children?.[0]}></Slot>
        </div>
        <div className={classes.Center}>
            <Slot name='center' children={children?.[1]}></Slot>
        </div>
        <div className={classes.Right}>
            <Slot name='right' children={children?.[2]}></Slot>
        </div>
    </div>
}

const MeChildHeader = props => {
    useStyles(classes)
    const { name, style, onBack } = props || []
    const history = useHistory()

    return <MeHeaderBase className={`${props?.className}`}>
                <Iconfont
                    className={classes.BackIcon}
                    slot='left'
                    onClick={() => {
                        if(props?.onBack){
                            props?.onBack()
                        } else {
                            history.goBack()
                        }
                    }}
                    >
                        &#xe693;
                </Iconfont>
                <span slot='center'>{ name || 'Settings' }</span>
            </MeHeaderBase>
}

export default MeChildHeader